import { useEffect, useState } from "react";
import CustomSvg from "../svgs/CustomSvg";
import { formatDateDash } from "../../utils";
import { getRequest } from "../apiRequests/requestApi";
import { Spinner } from "react-bootstrap";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Coin from "../../assets/images/coin.svg";

export default function TransacHistory() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 5;

  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  useEffect(() => {
    const get = async () => {
      try {
        const response = await getRequest("/transactions");

        if (!response.data) {
          setTransactions(null);
          return;
        }

        const data = response.data;

        const filtered = data.filter(
          (tx) => tx.status !== "pending" && tx.status !== "failed"
        );

        const newArray = filtered.map(
          ({ amount, createdAt, type, ref, description }) => ({
            ref,
            amount: amount / 100,
            date: formatDateDash(createdAt),
            type,
            description,
          })
        );

        setTransactions(newArray);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    get();
  }, []);

  // Pagination logic
  const indexOfLast = currentPage * transactionsPerPage;
  const indexOfFirst = indexOfLast - transactionsPerPage;
  const currentTransactions =
    transactions?.slice(indexOfFirst, indexOfLast) || [];
  const totalPages = transactions
    ? Math.ceil(transactions.length / transactionsPerPage)
    : 1;
  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  currentTransactions.map((transac, i) => {
    const { type, amount, date, ref, description } = transac;

    return (
      <div
        key={i}
        className="d-flex align-items-center justify-content-between mb-4 p-3"
        style={{
          background: "rgba(255,255,255,0.07)",
          borderRadius: 12,
          borderLeft: `4px solid ${
            type === "withdrawal" ? "#E75547" : "#4FC143"
          }`,
          boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="p-2 rounded-circle user-profile-transac-history-transac-icon-container"
            style={{ background: "#232323" }}
          >
            <CustomSvg
              name={
                type === "withdrawal" ? "withdrawal-arrow" : "deposit-arrow"
              }
            />
          </div>
          <div className="mx-2 px-2">
            <h5 className=" mb-1 text-white  font-family-poppins text-sm">
              {type === "withdrawal" ? "Cash Withdrawal" : "Funds Added"}
            </h5>
            <p className=" text-[#979797] text-xs font-family-poppins font-weight-400 letter-spacing-_12">
              {ref}
              {description || "No description provided"}
            </p>
            <p className=" text-[#979797] text-xs font-family-poppins font-weight-400 letter-spacing-_12"></p>
          </div>
        </div>
        <div>
          <h5
            className={`${
              type === "withdrawal" ? "txt-E75547" : "txt-4FC143"
            }  mb-1 text-sm text-white font-family-poppins font-weight-500`}
          >
            &#8358;{amount.toLocaleString()}
          </h5>
          <p className=" text-[#979797] font-family-poppins text-xs ">{date}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="dashboard">
      <div className="d-flex flex-wrap justify-content-between col-lg-12 w-100 col-12">
        <div className="col-lg-9 col-md-9 col-12 px-lg-5 px-md-5 px-2 bg-[#130828]">
          <div className="flex items-center gap-16 my-10">
            <button
              onClick={() => navigateTo("/")}
              className=" "
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                padding: 0,
              }}
            >
              <CustomSvg
                name="arrow-left"
                width={20}
                height={20}
                color="#fff"
              />
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                }}
              >
                <AiOutlineArrowLeft width={30} height={30} />
              </span>
            </button>
            <h2 className="text-2xl text-white text-center font-semibold  ">
              Transaction History
            </h2>
          </div>

          {loading ? (
            <div className="flex items-center gap-2 text-white">
              <p className="text-sm font-semibold">
                Retrieving transactions...
              </p>
              <Spinner size="sm" variant="light" />
            </div>
          ) : currentTransactions && currentTransactions.length > 0 ? (
            <>
              {currentTransactions.map((transac, i) => {
                const { type, amount, date, ref, description } = transac;

                return (
                  <div
                    key={i}
                    className="flex items-center justify-between mb-4 p-3 rounded-xl shadow-md"
                    style={{
                      background: "rgba(255,255,255,0.07)",
                      borderLeft: `4px solid ${
                        type === "withdrawal" ? "#E75547" : "#4FC143"
                      }`,
                    }}
                  >
                    <div className="flex items-center">
                      <div
                        className="p-2 rounded-full"
                        style={{ background: "#232323" }}
                      >
                        <CustomSvg
                          name={
                            type === "withdrawal"
                              ? "withdrawal-arrow"
                              : "deposit-arrow"
                          }
                        />
                      </div>
                      <div className="ml-4">
                        <h5 className="text-white font-semibold text-sm">
                          {type === "withdrawal"
                            ? "Cash Withdrawal"
                            : "Funds Added"}
                        </h5>
                        <p className="text-[#979797] text-xs">{ref}</p>
                        <p className="text-[#c6c3c3] text-xs">{description}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <h5
                        className={`text-sm font-semibold ${
                          type === "withdrawal"
                            ? "text-[#E75547]"
                            : "text-[#4FC143]"
                        }`}
                      >
                        <img
                          src={Coin}
                          alt="coin"
                          className="w-5 h-5 inline-block align-middle mb-1 mr-1"
                        />
                        {amount.toLocaleString()}
                      </h5>
                      <p className="text-[#979797] text-xs">{date}</p>
                    </div>
                  </div>
                );
              })}

              <div className="flex justify-center items-center mt-6 gap-4">
                <button
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                  className="px-4 py-1 border border-white rounded-lg text-white hover:bg-white hover:text-black transition disabled:opacity-40"
                >
                  Prev
                </button>
                <span className="text-white text-sm">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className="px-4 py-1 border border-white rounded-lg text-white hover:bg-white hover:text-black transition disabled:opacity-40"
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p className="text-white text-sm font-semibold">
              No transactions found
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
